import { ReactNode, useState } from "react";
import styles from './TabControl.module.css';

interface TabPage {
  title: string;
  content: ReactNode;
}

interface Props {
  pages: TabPage[],
  initialActiveIndex?: number;
}


const TabControl = (props: Props) => {
  const [activeTabIndex, setActiveTabIndex] = useState(props.initialActiveIndex || 0);


  const tabPageCornerClassName = activeTabIndex === 0 ? styles.firstTabSelected : (activeTabIndex === props.pages.length - 1) ? styles.lastTabSelected : '';
  return (
    <div className={styles.tabControl}>
      <div className={styles.tabBar}>
        {props.pages.map((x, index) =>
          <button key={index} className={index === activeTabIndex ? styles.selected : undefined} onClick={() => setActiveTabIndex(index) }>{x.title}</button>)
        }
      </div>
      <div className={`${styles.tabPage} ${tabPageCornerClassName}`}>
        <div className={styles.tabPageInner}>
          {props.pages[activeTabIndex].content}
          </div>
      </div>
    </div>

  );
};


export default TabControl;